import { render, staticRenderFns } from "./ChatInput.vue?vue&type=template&id=9418d45e"
import script from "./ChatInput.vue?vue&type=script&lang=js"
export * from "./ChatInput.vue?vue&type=script&lang=js"
import style0 from "./ChatInput.vue?vue&type=style&index=0&id=9418d45e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports